import dataBase from '@/dataBase/database'
import { reportService } from '@/_services'
import { fileService } from './file.service'
import { motivationalReportService } from './motivationalReport.service'
class SyncManager {
  constructor() {
    this._store = null
  }

  init(store) {
    this._store = store
    window.addEventListener('offline', () => {
      this._store.commit('pointreport/setIsOnline', false)
      window.dispatchEvent(new CustomEvent('app:online-sync'))
    })
    window.addEventListener('online', async () => { 
      // await this.syncAll();
      window.dispatchEvent(new CustomEvent('app:online-sync'));
      this._store.commit('pointreport/setIsOnline', true);
    });
  }

  async syncAll() {
    if (!navigator.onLine) return
    this._store.commit('pointreport/setLoadingAsync', true)

    try {
      let totalReportData = await dataBase.productReportData.where('synced').equals(0).count()
      let totalPointReports = await dataBase.pointReport.where('synced').equals(0).count()
      let totalDmpReports = await dataBase.motivationalDmpReport.where('synced').equals(0).count()
      let unsyncedMotivationalDmp = await dataBase.motivationalDmp.where('synced').equals(0).count()
      const total = totalReportData + totalPointReports + totalDmpReports

      if (totalReportData === 0 && totalPointReports === 0 && totalDmpReports === 0 && unsyncedMotivationalDmp === 0) return

      const progress = { done: 0, total }
      this._store.commit('pointreport/setSyncProgress', { ...progress })

      await this._syncReportData(progress)
      await this._syncPointReports(progress)
      await this._syncDmpReports(progress)
      await this._syncMotivationalDmp()
    } catch (err) {
      console.error('[SyncManager]', err)
    } finally {
      this._store.commit('pointreport/setLoadingAsync', false)
    }
  }

  async _syncReportData(progress) {
    let unsynced = await dataBase.productReportData.where('synced').equals(0).toArray()
    for (let item of unsynced) {
      try {
        let uploadedPhotos = await this._uploadPhotos(item.id, 'product')
        await reportService.sendReportData({
          projectId:      item.projectId,
          tradePointId:   item.pointId,
          productId:      item.productId,
          reportItemInfo: item.data,
          comment:        item.data.comment,
          presense:       item.data.presense,
          photos:         uploadedPhotos,
        })

        await dataBase.productReportData.update(item.id, { synced: 1 })
      } catch (err) {
        console.error(`[SyncManager] Ошибка reportData ${item.id}:`, err)
      }
      progress.done++
      this._store.commit('pointreport/setSyncProgress', { ...progress })
    }
  }

  async _syncPointReports(progress) {
    let unsynced = await dataBase.pointReport.where('synced').equals(0).toArray()

    for (let item of unsynced) {
      try {
        let uploadedPhotos = await this._uploadPhotos(String(item.pointId))
        await reportService.sendPreReport({
          projectId:    item.projectId,
          tradePointId: item.pointId,
          comment:      item.comment,
          tempPhotos:   uploadedPhotos,
          reportPhoto: item.reportPhoto
        })

        await dataBase.pointReport.update(item.id, { synced: 1 })
      } catch (err) {
        console.error(`[SyncManager] Ошибка pointReport ${item.id}:`, err)
      }
      progress.done++
      this._store.commit('pointreport/setSyncProgress', { ...progress })
    }
  }

  async _syncMotivationalDmp() {
    const unsynced = await dataBase.motivationalDmp.where('synced').equals(0).toArray()

    for(const dmp of unsynced) {
      try {
        let motivationalReportServerId
        const motivationalReport = await dataBase.motivationalReport.get(Number(dmp.localMotivationalReportId))
        if(!motivationalReport.serverId) {
          let motivationalReportData = await motivationalReportService.loadMyMotivation(motivationalReport.projectId, motivationalReport.networkId, motivationalReport.pointId)
          motivationalReportServerId = motivationalReportData.id
          await dataBase.motivationalReport.update(motivationalReportData.id, { serverId: data.id, synced: 1 })
        } else motivationalReportServerId = motivationalReport.serverId
        let data = await motivationalReportService.createDmp({ id: dmp.serverId, dmpCategory: dmp.dmpCategory, comment: dmp.comment }, motivationalReportServerId)
        await dataBase.motivationalDmp.update(dmp.id, { serverId: data.id, synced: 1 })
      } catch (error) {
        console.error(`[SyncManager] Ошибка motivationalDmp ${dmp.id}:`, error)
      }
    }
  }

  async _syncDmpReports(progress) {
    const unsynced = await dataBase.motivationalDmpReport.where('synced').equals(0).toArray()

    for (const report of unsynced) {
      try {
        let serverDmpId
        const dmp = await dataBase.motivationalDmp.get(Number(report.localDmpId))
        if (dmp.serverId) {
          serverDmpId = dmp.serverId
        } else {
          let motivationalReportServerId
          const motivationalReport = await dataBase.motivationalReport.get(Number(dmp.localMotivationalReportId))
          if(!motivationalReport.serverId) {
            let data = await motivationalReportService.loadMyMotivation(motivationalReport.projectId, motivationalReport.networkId, motivationalReport.pointId)
            motivationalReportServerId = data.id
            await dataBase.motivationalReport.update(dmp.id, { serverId: data.id, synced: 1 })
          } else motivationalReportServerId = motivationalReport.serverId
          let data = await motivationalReportService.createDmp({ id: dmp.serverId, dmpCategory: dmp.dmpCategory, comment: dmp.comment }, motivationalReportServerId)
          serverDmpId = data.id
          await dataBase.motivationalDmp.update(dmp.id, { serverId: serverDmpId, synced: 1 })
        }

        const uploadedPhotos = await this._uploadPhotos(`${dmp.localMotivationalReportId}_${dmp.id}`)
        await motivationalReportService.sendReportDmp(serverDmpId, {dmpCategory: report.dmpCategory, reportPhoto: uploadedPhotos})

        await dataBase.motivationalDmpReport.update(report.id, { synced: 1 })

      } catch (err) {
        console.error(`[SyncManager] Ошибка motivationalDmpReport ${report.id}:`, err)
      }

      progress.done++
      this._store.commit('pointreport/setSyncProgress', { ...progress })
    }
  }

  async _uploadPhotos(reportId) {
    let photos = await dataBase.photos.where('reportId').equals(String(reportId)).filter(p => p.synced === 0).toArray()
    let uploaded = []

    for (let photo of photos) {
      try {
        let formData = new FormData()
        formData.append('files[]', photo.blob, photo.fileName)

        let data = await fileService.uploadFiles(formData, photo.motivational ? true : false, photo.dmp && photo.motivational ? true : false, () => {})
        data.forEach(x => x.dmp = photo.dmp)

        await dataBase.photos.update(photo.id, { offline: false, synced: 1 })
        uploaded.push(...data)
      } catch (err) {
        console.error(`[SyncManager] Ошибка загрузки фото ${photo.id}:`, err)
      }
    }

    return uploaded
  }
}

export default new SyncManager()